import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const invoiceListTodo = createAsyncThunk('invoiceList', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `invoice`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'invoiceDate': data?.invoiceDate && moment(data?.invoiceDate).format('YYYY-MM-DD'),
                'customerId': data?.customerId,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const invoiceListSlice = createSlice({
    name: 'invoiceList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(invoiceListTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(invoiceListTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default invoiceListSlice.reducer; 